function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
function Generic(tp,pred,d){const f=(...args)=>{const t={description:d||'generic',__runtimeType:true,check:v=>pred(v,...args)};return t};f.__runtimeType=true;f.description=d;return f};
function FunctionPredicate(n,s,b){if(Array.isArray(s)&&b){const f=(...a)=>FunctionPredicate(n,b(...a));f.typeParamNames=s.map(p=>Array.isArray(p)?p[0]:p);f.description=n;f.__runtimeType=true;return f}const spec=typeof s==='function'?{}:s||{};return{description:n,params:spec.params||{},returns:spec.returns,returnContract:spec.returnContract||'assertReturns',check:v=>typeof v==='function',__runtimeType:true}};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {Type,Generic,FunctionPredicate};
/* tjs <- xin-types.ts */

import { XIN_PATH, XIN_VALUE, XIN_OBSERVE, XIN_BIND, TOSI_ACCESSOR, TAKE_DESCRIPTOR } from './metadata'

import { XinStyleRule } from './css-types'

import { ElementsProxy } from './elements-types'

export const AnyFunction = FunctionPredicate('AnyFunction', { params: { args: [null] }, returns: null })

export const XinScalar = Type('XinScalar')

export const XinArray = Type('XinArray', undefined, [null])

export const XinObject = Type('XinObject')

export const XinProxyTarget = Type('XinProxyTarget')

export const XinValue = Type('XinValue')

const ProxyObserveFunc = Type('ProxyObserveFunc')

const ProxyBindFunc = FunctionPredicate('ProxyBindFunc', [['T', {}]], (T) => ({ params: { element: T, binding: null, options: null }, returns: null }))

export const TakeDescriptor = Type('TakeDescriptor', undefined, { [TAKE_DESCRIPTOR]: true, paths: [''], transform: FunctionPredicate('function', { params: { values: [null] }, returns: null }) })

export const TosiAccessor = Generic([['T', null]], (x, checkT) => { return typeof x === 'object' && x !== null && 'value' in x && checkT(x.value) && 'path' in x && 'touch' in x && 'observe' in x && 'bind' in x && 'on' in x && 'binding' in x && 'listBinding' in x && 'listFind' in x && 'listUpdate' in x && 'listRemove' in x && 'take' in x }, 'TosiAccessor')

export const XinProps = Generic([['T', null]], (x, checkT) => { return typeof x === 'object' && x !== null && TOSI_ACCESSOR in x && 'tosi' in x && 'path' in x && 'value' in x && checkT(x.value) && 'touch' in x && 'observe' in x && 'bind' in x && 'on' in x && 'binding' in x && 'valueOf' in x && 'toJSON' in x && XIN_PATH in x && 'tosiPath' in x && XIN_VALUE in x && checkT(x[XIN_VALUE]) && 'tosiValue' in x && checkT(x.tosiValue) && XIN_OBSERVE in x && 'tosiObserve' in x && XIN_BIND in x && 'tosiBind' in x }, 'XinProps')

const ListTemplateBuilder = FunctionPredicate('ListTemplateBuilder', [['U', null]], (U) => ({ params: { elements: null, item: U, columnIndex: 0.0 }, returns: {} }))

const ListBinding = Type('ListBinding', undefined, [null, {}])

const ListFieldSelector = FunctionPredicate('ListFieldSelector', ['U'], (U) => ({ params: { item: null }, returns: null }))

export const BoxedArrayProps = Generic([['U', null]], (x, checkU) => { return typeof x === 'object' && x !== null && 'listBinding' in x && 'tosiListBinding' in x && 'listFind' in x && 'listUpdate' in x && 'listRemove' in x }, 'BoxedArrayProps')

const BoxedScalarAPI = Generic(['T'], (x, checkT) => { return typeof x === 'object' && x !== null && TOSI_ACCESSOR in x && 'tosi' in x && 'value' in x && checkT(x.value) && 'path' in x && 'touch' in x && 'observe' in x && 'bind' in x && 'on' in x && 'binding' in x && 'listBinding' in x && 'valueOf' in x && 'toString' in x && 'toJSON' in x && 'xinValue' in x && checkT(x.xinValue) && 'xinPath' in x && 'tosiValue' in x && checkT(x.tosiValue) && 'tosiPath' in x && 'xinObserve' in x && 'tosiObserve' in x && 'xinBind' in x && 'tosiBind' in x && 'xinOn' in x && 'tosiOn' in x && 'tosiBinding' in x }, 'BoxedScalarAPI')

export const BoxedScalar = Generic(['T'], (x, checkT) => { return true }, 'BoxedScalar')

export const BoxedProxy = Generic([['T', null]], (x, checkT) => { return true }, 'BoxedProxy')

export const Unboxed = Generic([['T', null]], (x, checkT) => { return true }, 'Unboxed')

export const XinProxy = Generic([['T', null]], (x, checkT) => { return true }, 'XinProxy')

export const XinProxyObject = Type('XinProxyObject')

export const XinProxyArray = Type('XinProxyArray')

export const XinTouchableType = Type('XinTouchableType')

export const EventType = Type('EventType')

export const XinEventHandler = Generic([['T', {}], ['E', {}]], (x, checkT, checkE) => { return true }, 'XinEventHandler')

export const XinBindingShortcut = Type('XinBindingShortcut')

const _BooleanFunction = FunctionPredicate('_BooleanFunction', { returns: false })

const _PathTestFunction = FunctionPredicate('_PathTestFunction', { params: { path: '' }, returns: null })

export const PathTestFunction = Type('PathTestFunction')

const OptionalSymbol = Type('OptionalSymbol')

const _CallbackFunction = Type('_CallbackFunction')

const _PathCallbackFunction = Type('_PathCallbackFunction')

export const ObserverCallbackFunction = Type('ObserverCallbackFunction')

export const XinBindingSpec = Type('XinBindingSpec', undefined, { value: null })

export const XinBindingSetter = FunctionPredicate('XinBindingSetter', [['T', {}]], (T) => ({ params: { element: T, value: null, options: null } }))

export const XinBindingGetter = FunctionPredicate('XinBindingGetter', [['T', {}]], (T) => ({ params: { element: T, options: null }, returns: null }))

export const XinBinding = Generic([['T', {}]], (x, checkT) => { return typeof x === 'object' && x !== null && 'toDOM' in x && 'fromDOM' in x }, 'XinBinding')

export const XinInlineBinding = Generic([['T', {}]], (x, checkT) => { return typeof x === 'object' && x !== null && 'value' in x && 'binding' in x }, 'XinInlineBinding')

export const ElementProps = Generic([['T', {}]], (x, checkT) => { return typeof x === 'object' && x !== null && 'onClick' in x && 'onMousedown' in x && 'onMouseenter' in x && 'onMouseleave' in x && 'onMouseup' in x && 'onTouchstart' in x && 'onTouchmove' in x && 'onTouchend' in x && 'onTouchcancel' in x && 'onDragstart' in x && 'onDragover' in x && 'onDragend' in x && 'onDragenter' in x && 'onDragleave' in x && 'onInput' in x && 'onChange' in x && 'onSubmit' in x && 'onKeydown' in x && 'onKeyup' in x && 'bind' in x && 'bindValue' in x && 'bindText' in x && 'bindList' in x && 'bindEnabled' in x && 'bindDisabled' in x && 'style' in x && 'class' in x && 'apply' in x }, 'ElementProps')

export const StringMap = Type('StringMap')

export const PartsMap = Type('PartsMap')

export const ValueElement = Type('ValueElement', undefined, {})

export const ElementPart = Generic([['T', {}]], (x, checkT) => { return true }, 'ElementPart')

export const HTMLElementCreator = FunctionPredicate('HTMLElementCreator', [['T', {}]], (T) => ({ params: { contents: [null] }, returns: T }))

export const FragmentCreator = FunctionPredicate('FragmentCreator', { params: { contents: [null] }, returns: {} })

export const ElementCreator = FunctionPredicate('ElementCreator', [['T', {}]], (T) => ({ params: { contents: [null] }, returns: T }))

export const ContentPart = Type('ContentPart', undefined, {})

export const ContentType = Type('ContentType')

export const ListFilter = FunctionPredicate('ListFilter', { params: { array: [null], needle: null }, returns: [null] })

export const ListBindingOptions = Type('ListBindingOptions', undefined, { idPath: '', virtual: { height: 0.0, minHeight: 0.0, width: 0.0, visibleColumns: 0.0, rowChunkSize: 0.0, scrollContainer: 'window' | 'element', itemsPerRow: 0.0 }, hiddenProp: null, visibleProp: null, filter: null, needle: null })